import React from "react";
import Video from "./Video";

export default function VideosList({ recipes }) {
  console.log(recipes);
  return (
    <section className="videos" id="featured-videos">
      <div className="video-grid front-page" id="front-page-videos">
        <ul className="video-list featured">
          {recipes.map((recipe) => (
            <Video key={recipe.youTubeId} recipe={recipe} />
          ))}
        </ul>
      </div>
    </section>
  );
}
